import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeRoulottes = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"ListeRoulottes"}/>
        </div>
    );
}
export default ListeRoulottes;